import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { forwardRef, useEffect } from 'react';
// material
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

// ----------------------------------------------------------------------
const RootStyle = styled(Box)(({ theme }) => ({
  maxWidth: '1440px',

  [theme.breakpoints.up('xs')]: {
    width: `100%`,
    padding: '0px 15px 30px'
  },
  [theme.breakpoints.up('sm')]: {
    width: `100%`,
    padding: '0px 20px 30px'
  },
  [theme.breakpoints.up('md')]: {
    width: `100%`,
    padding: '0px 20px 60px'
  },
  [theme.breakpoints.up('lg')]: {
    width: `100%`,
    padding: '0px 90px 70px'
  }
}));

const Page = forwardRef(
  (
    { children, title = '', description = '', canonical, microdata = null, isIndex, ...other },
    ref
  ) => {
    useEffect(() => {
      if (microdata) {
        const scriptId = 'microdata-json-ld';
        if (!document.getElementById(scriptId)) {
          const script = document.createElement('script');
          script.type = 'application/ld+json';
          script.id = scriptId;
          script.text = JSON.stringify(microdata);
          document.head.appendChild(script);
        }

        // Опціонально: якщо хочемо видаляти на демонтажі
        return () => {
          const existingScript = document.getElementById(scriptId);
          if (existingScript) {
            document.head.removeChild(existingScript);
          }
        };
      }
    }, [microdata]);

    return (
      <RootStyle ref={ref} {...other}>
        <Helmet>
          <title>{title}</title>
          <meta name="description" content={description} />
          <meta itemProp="name" content={title} />
          <meta itemProp="description" content={description} />
          <meta name="robots" content={isIndex ? 'index, follow' : 'noindex, nofollow'} />
          {canonical && <link rel="canonical" href={canonical} />}
          {isIndex && (
            <>
              <script
                async
                src="https://www.googletagmanager.com/gtag/js?id=AW-17512636363"
              ></script>
              <script>
                {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'AW-17512636363');
        `}
              </script>
            </>
          )}
          {/*{microdata && (*/}
          {/*    <script*/}
          {/*        type="application/ld+json"*/}
          {/*        dangerouslySetInnerHTML={{__html: JSON.stringify(microdata)}}*/}
          {/*    />*/}
          {/*)}*/}
        </Helmet>
        {children}
      </RootStyle>
    );
  }
);

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string
};

export default Page;
